module.exports = __webpack_public_path__ + "img/walkthrough_portfolio.82843222.gif";